module.exports = __webpack_public_path__ + "static/media/livraria.699d29d1.svg";